import { Class } from "core/Abacus.Utilities";

$(function() {
  $(".has-expandable-list").each(function() {
    new Taxonomy(this);
  });
});

class Taxonomy extends Class {
  constructor(element, options) {
    super();
    this.element = element;
    this.setOptions(options);
    this.toggleExpandable();
    this.findLastList();
  }

  toggleExpandable() {
    var self = this;
    $(this.element)
      .find(".trigger")
      .on("click", function(evt) {
        evt.preventDefault();
        $(self.element).toggleClass("open");
        $(this)
          .next()
          .attr("aria-expanded") == "true"
          ? $(this)
              .next()
              .attr("aria-expanded", "false")
          : $(this)
              .next()
              .attr("aria-expanded", "true");
      });
  }

  findLastList() {
    $(this.element).each(function() {
      $(this)
        .find("ul")
        .each(function() {
          if (
            !$(this).find("ul").length &&
            !$(this)
              .parent("li")
              .hasClass("has-expandable-list")
          ) {
            $(this).addClass("last-list");
          }
        });
    });
  }
}



// WEBPACK FOOTER //
// ./Javascript/core/classes/taxonomy/taxonomy.class.js